import { c as _c } from "react/compiler-runtime";
import { useIsDesktop } from './useIsDesktop';
import { useIsMobileScreen } from './useIsMobileScreen';

/**
 * Combined hook that returns device type information
 * @param mobileBreakpoint - Screen width breakpoint for mobile detection (default: 768)
 */
export function useDeviceType(t0) {
  const $ = _c(5);
  const mobileBreakpoint = t0 === undefined ? 768 : t0;
  const isDesktop = useIsDesktop();
  const isMobileScreen = useIsMobileScreen(mobileBreakpoint);
  const t1 = !isDesktop;
  const t2 = isMobileScreen || !isDesktop;
  let t3;
  if ($[0] !== isDesktop || $[1] !== isMobileScreen || $[2] !== t1 || $[3] !== t2) {
    t3 = {
      isDesktop,
      isMobileScreen,
      isTouchDevice: t1,
      shouldUseMobileUI: t2
    };
    $[0] = isDesktop;
    $[1] = isMobileScreen;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}